import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "container-fluid pb-4",
  id: "Topics"
}
const _hoisted_2 = { class: "row mt-5 d-flex flex-row justify-content-center align-items-center" }
const _hoisted_3 = { class: "inner col-12 col-lg-11 col-xl-10 d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"row d-flex flex-column flex-lg-row justify-content-center align-items-center top\"><p class=\"col-12 col-lg-3 mb-0 title\"><span class=\"number\">1. </span><span>Elige un tema</span></p><div class=\"col-12 col-lg-1 mt-2 mb-4 my-lg-0 d-flex justify-content-center align-items-center\"><div class=\"line\"></div></div><p class=\"col-11 col-lg-8 mb-0 text text-center text-lg-start\">La Encuesta Nacional de Cultura Cívica (ENCUCI) 2020 está estructurada en seis temas principales. Escoge uno para conocer las preguntas y los datos específicos de cada sección.</p></div>", 1)
const _hoisted_5 = { class: "row mt-5 d-flex flex-row justify-content-center align-items-center sub" }
const _hoisted_6 = { class: "col-12 col-lg-4 p-3" }
const _hoisted_7 = { class: "col-10 pt-5 pb-3 px-4" }
const _hoisted_8 = { class: "card-box" }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = { class: "btn-box d-flex justify-content-center align-items-center" }
const _hoisted_11 = { class: "col-12 p-4 pb-3 d-flex flex-row justify-content-start align-items-center" }
const _hoisted_12 = { class: "p-box col-7 d-flex justify-content-start align-items-center" }
const _hoisted_13 = { class: "btn-box col-5 d-flex justify-content-center align-items-center" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "description" }
const _hoisted_16 = ["data-bs-target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_smooth_scroll = _resolveDirective("smooth-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (s) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "card d-none d-lg-flex flex-row",
                style: _normalizeStyle(`background-color: ${s.color}33`)
              }, [
                _createElementVNode("div", {
                  class: "col-2 ribbon",
                  style: _normalizeStyle(`background-color: ${s.color}`)
                }, null, 4),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", {
                      class: "title text-uppercase",
                      style: _normalizeStyle(`color: ${s.color}`)
                    }, _toDisplayString(s.title), 5),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.features, (f) => {
                          return (_openBlock(), _createElementBlock("li", null, _toDisplayString(f), 1))
                        }), 256))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                      class: "btn py-2 px-4",
                      onClick: ($event: any) => {_ctx.changeTopic([s]); _ctx.changeMainTopic(s);},
                      to: "/",
                      href: "#Questions",
                      style: _normalizeStyle(`border: solid 1px ${s.color}; color: ${s.color}`)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("EXPLORAR")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "style"])), [
                      [_directive_smooth_scroll]
                    ])
                  ])
                ])
              ], 4),
              _createElementVNode("div", {
                class: "card d-flex d-lg-none flex-column",
                style: _normalizeStyle(`background-color: ${s.color}33`)
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", {
                      class: "mb-0 title text-uppercase",
                      style: _normalizeStyle(`color: ${s.color}`)
                    }, _toDisplayString(s.title), 5)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                      class: "btn py-2 px-4",
                      to: "/",
                      href: "#Questions",
                      onClick: ($event: any) => (_ctx.changeMainTopic(s)),
                      style: _normalizeStyle(`border:solid 1px ${s.color}; color: ${s.color}`)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("EXPLORAR")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "style"])), [
                      [_directive_smooth_scroll]
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "collapse p-4 pt-0",
                  id: `collapseExample${s.id}`
                }, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(s.description), 1)
                ], 8, _hoisted_14),
                _createElementVNode("button", {
                  class: "btn btn-collapse",
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": `#collapseExample${s.id}`,
                  "aria-expanded": "false",
                  "aria-controls": "collapseExample",
                  style: _normalizeStyle(`background-color: ${s.color}`)
                }, null, 12, _hoisted_16)
              ], 4)
            ]))
          }), 256))
        ])
      ])
    ])
  ]))
}